{
  "evaluationPublished": "The evaluation for {{respondentEmail}} is ready",
  "evaluationReady": "Your evaluation from {{tenantName}} is ready",
  "selfProfileReady": "Your profile is ready to start",
  "assignmentsSent": "Your questionnaires have been sent",
  "creditsReady": "Your credits are ready",
  "aiProfilingReady": "The AI draft for {{respondentName}} is ready",
  "aiProfilingFailed": "The AI draft for {{respondentName}} failed",
  "view": "View",
  "start": "Start"
}
